var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountledger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1580_1039)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 233.996,
    fill: "white",
    stroke: "white",
    strokeWidth: 32.0088
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.562 87.1965H217.468C222.35 87.1965 226.308 91.1545 226.308 96.0369V120.178H183.722V96.0369C183.722 91.1545 187.68 87.1965 192.562 87.1965Z",
    fill: "#FEF4E8",
    stroke: "black",
    strokeWidth: 11.0375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.414 385.811H227.834V419.426L204.224 406.62L181.414 419.426V385.811Z",
    fill: "#FEF4E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.553 122.479H340.489C353.319 122.479 355.886 126.581 355.886 133.761V375.815C355.886 387.61 340.489 387.61 340.489 387.61L261.045 387.61L157.352 387.61C157.295 387.61 157.247 387.614 157.191 387.621C156.16 387.765 144.951 389.025 144.949 375.815C144.948 361.978 144.949 170.929 144.949 170.685V170.684V140.427C144.949 133.761 141.356 122.479 157.267 122.479H182.928H226.553Z",
    fill: "#FEF4E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.553 390.687V417.165C226.553 417.944 225.72 418.439 225.036 418.066L204.479 406.862C204.164 406.69 203.781 406.696 203.471 406.877L184.472 417.99C183.788 418.39 182.928 417.897 182.928 417.104V390.687M340.489 122.479C327.66 122.479 226.553 122.479 226.553 122.479C226.553 122.479 226.553 122.479 226.553 122.479H182.928C182.928 122.479 182.928 122.479 182.928 122.479C182.928 122.479 169.071 122.479 157.267 122.479C141.356 122.479 144.949 133.761 144.949 140.427C144.949 147.094 144.949 170.684 144.949 170.684C144.949 170.684 144.949 170.684 144.949 170.684C144.949 170.684 144.948 361.969 144.949 375.815C144.951 389.024 156.16 387.765 157.191 387.621C157.247 387.614 157.295 387.61 157.352 387.61L261.045 387.61L340.489 387.61C340.489 387.61 340.489 387.61 340.489 387.61C340.489 387.61 355.886 387.61 355.886 375.815C355.886 364.02 355.886 140.94 355.886 133.761C355.886 126.581 353.319 122.479 340.489 122.479Z",
    stroke: "black",
    strokeWidth: 11.0375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.602,
    y1: 171.319,
    x2: 173.32,
    y2: 171.319,
    stroke: "black",
    strokeWidth: 11.0375
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.602,
    y1: 197.986,
    x2: 173.32,
    y2: 197.986,
    stroke: "black",
    strokeWidth: 11.0375
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.594,
    y1: 225.166,
    x2: 173.33,
    y2: 225.166,
    stroke: "black",
    strokeWidth: 11.0375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.398 169.023H312.81C317.692 169.023 321.65 172.981 321.65 177.863V235.3C321.65 240.182 317.692 244.14 312.81 244.14H216.398C211.516 244.14 207.558 240.182 207.558 235.3V177.863C207.558 172.981 211.516 169.023 216.398 169.023Z",
    fill: "#FEF4E8",
    stroke: "black",
    strokeWidth: 11.0375
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.706,
    y1: 124.529,
    x2: 173.706,
    y2: 387.097,
    stroke: "black",
    strokeWidth: 11.0375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.516 219.646H289.197",
    stroke: "#4045A1",
    strokeWidth: 15.9823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.516 194.261H289.197",
    stroke: "#4045A1",
    strokeWidth: 15.9823,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1580_1039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountledger);
export default __webpack_public_path__ + "static/media/accountledger.d310b473b6d9d34fe6f7b5d68895583f.svg";
export { ForwardRef as ReactComponent };